
import * as actionTypes from './actionType';

export const selectReport = (reportID) => { return {type: actionTypes.SET_REPORT, 'currentReportID': reportID} }
